import config from '@/../version.json'

function random4() {
	return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

function randomX() {
	return Math.random().toString().slice(2, 10) + Math.random().toString().slice(2, 10)
}

export function getPageId() {
	return (
		new Date().getTime() + '-' + random4() + '-' + random4() + '-' + random4() + '-' + random4() + random4() + random4()
	)
}

//对象去除空
export function delEmptyValues(obj) {
	for (let key in obj) {
		let value = obj[key]
		if (value === null || value === '' || value === undefined) {
			delete obj[key]
		} else if (typeof value === 'object' && value.length === 0) {
			delete obj[key]
		}
	}
	return obj
}

export function getSecretData() {
	let version = config.version
	let versionTime = parseInt(config.date)
	return ['x'.concat('i').concat('d').concat(version.slice(-1)), `${randomX()}${Date.now() - versionTime}${randomX()}`]
}
